import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsGastro(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Software 100 % na míru",
			desc: "Šablony a krabicová řešení sp[[necháváme na jiných]]. Ve Fastest děláme veškerá řešení pro firmy (nejen) z oblasti HORECA sp[[100% na míru.]]",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Nejsme jen vývojáři",
			desc: "Máme přesah do sp[[narovnávání firemních procesů, digitalizace nebo automatizace]]. Pomůžeme vám sp[[snížit]] náklady a sp[[ušetřit]] čas.",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Podpora a snadné škálování",
			desc: "Po celou dobu provozování systémů vám bude k ruce naše sp[[specializovaná podpora]]. Jakýkoliv software můžeme do budoucna snadno sp[[přizpůsobit vašim potřebám.]]",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Vyvíjíme na cloudu",
			desc: "Specializujeme se na sp[[cloudová řešení]], tím vám ušetříme peníze za servery, které byste jinak sp[[museli provozovat a starat se o ně.]]",
			bg: "bg-fstgrey-500",
		},
		{
			title: "V HORECA jsme jako doma",
			desc: "Pro sp[[hotely, restaurace nebo jiné gastro podniky]] vyvíjíme na míru už od roku 2016, do odvětví tak máme sp[[důkladný vhled.]]",
			bg: "bg-fstgrey-500",
		},
	];
}
